import {ApiService} from "./api.service";
import {AxiosResponse} from "axios";
import {Project, ProjectMetaData, ProjectWithJobHistories} from "../model/interface/project.interface";

export class ProjectService {
    public static async getAllProjects() {
        const url:string = ApiService.getInstance().getProjectsAllURL();
        const result: AxiosResponse<ProjectMetaData[]> | false = await ApiService.getInstance().get(url);
        if(result) {
            return <ProjectMetaData[]> result.data;
        } else {
            throw new Error('Error during Project fetch!');
        }
    }
    public static async getProject(projectId: number) {
        const url:string = ApiService.getInstance().getProjectURL(projectId);
        const result: AxiosResponse<ProjectWithJobHistories> | false = await ApiService.getInstance().get(url);
        if(result) {
            return <ProjectWithJobHistories> result.data;
        } else {
            throw new Error('Error during Project fetch!');
        }
    }
    public static async putProject(project:Project) {
        const url:string = ApiService.getInstance().getProjectURL(project.id);
        const result: AxiosResponse<Project> | false = await ApiService.getInstance().put(url, project);
        if(result) {
            return result.status;
        } else {
            throw new Error('Error during Project update!');
        }
    }
    public static async deleteProject(projectId:number) {
        const url:string = ApiService.getInstance().getProjectURL(projectId);
        const result: AxiosResponse<number> | false = await ApiService.getInstance().delete(url);
        if(result) {
            return <number> result.data;
        } else {
            throw new Error('Error during Project deletion!');
        }
    }
    public static async postProject(project:Project) {
        const url:string = ApiService.getInstance().getPostProjectURL();
        const result: AxiosResponse<Project> | false = await ApiService.getInstance().post(url,project);
        if(result) {
            return <Project> result.data;
        }
    }
    public static async getAllProjectMetaData() {
        const url:string = ApiService.getInstance().getProjectAllMetaURL();
        const result: AxiosResponse<ProjectMetaData[]> | false = await ApiService.getInstance().get(url);
        if(result) {
            return <ProjectMetaData[]> result.data;
        } else {
            throw new Error('Error during Project Metadata fetch!');
        }
    }
}